export const UserX = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10.6666 14V12.6667C10.6666 11.9594 10.3856 11.2811 9.88554
  10.781C9.38544 10.281 8.70716 10 7.99992 10H3.99992C3.29267 10 2.6144 10.281
  2.1143 10.781C1.6142 11.2811 1.33325 11.9594 1.33325 12.6667V14M11.3333 5.33333L14.6666
  8.66667M14.6666 5.33333L11.3333 8.66667M8.66658 4.66667C8.66658 6.13943 7.47268 7.33333
  5.99992 7.33333C4.52716 7.33333 3.33325 6.13943 3.33325 4.66667C3.33325 3.19391 4.52716
  2 5.99992 2C7.47268 2 8.66658 3.19391 8.66658 4.66667Z"
      stroke="#E7000B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
